import React from 'react'
import { ORGANIZATION_READ_ONLY } from '../../../../../role/hook/role-org'

// Why an impersonated session gets no schedule or restore where the person
// (an owner) would: the server refuses both while signed in as someone else
// (ruling R8), so the page says so beside the disabled control instead of
// offering one that will fail. readOnly comes from useRoleOrgOrganization.
// (A super admin no longer gets a note here: owner ruling 2026-10-07, the
// page follows their actual role in the organization.)
export const DeletionUnavailable = ({ readOnly, className = 'small mb-0' }) => {
  if (readOnly === ORGANIZATION_READ_ONLY.IMPERSONATED) {
    return <p className={className}>Deleting and restoring aren't available while you're signed in as someone else.</p>
  }

  return null
}
